import { Component } from '@angular/core';

import { newColors } from './data/new-colors.data';
import { NewColor } from './models/color.model';

@Component({
  selector: 'sh-new-colors',
  templateUrl: './new-colors.component.html',
  styleUrl: './new-colors.component.scss',
  standalone: false
})
export class NewColorsComponent {
  readonly newColors: NewColor[] = newColors;
}
